/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * IDF Repasses
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DoctorDetailOut,
  DoctorIn,
  DoctorPublicRepassesLinkOut,
  DoctorUpdate,
  HTTPValidationError
} from '../model';

import { apiClient } from '../../client';




/**
 * @summary List Doctors
 */
export const listDoctorsApiDoctorsGet = (

 signal?: AbortSignal
) => {


      return apiClient<DoctorDetailOut[]>(
      {url: `/api/doctors/`, method: 'GET', signal
    },
      );
    }




export const getListDoctorsApiDoctorsGetQueryKey = () => {
    return [
    `/api/doctors/`
    ] as const;
    }


export const getListDoctorsApiDoctorsGetQueryOptions = <TData = Awaited<ReturnType<typeof listDoctorsApiDoctorsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoctorsApiDoctorsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDoctorsApiDoctorsGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDoctorsApiDoctorsGet>>> = ({ signal }) => listDoctorsApiDoctorsGet(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDoctorsApiDoctorsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDoctorsApiDoctorsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listDoctorsApiDoctorsGet>>>
export type ListDoctorsApiDoctorsGetQueryError = unknown


export function useListDoctorsApiDoctorsGet<TData = Awaited<ReturnType<typeof listDoctorsApiDoctorsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoctorsApiDoctorsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDoctorsApiDoctorsGet>>,
          TError,
          Awaited<ReturnType<typeof listDoctorsApiDoctorsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDoctorsApiDoctorsGet<TData = Awaited<ReturnType<typeof listDoctorsApiDoctorsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoctorsApiDoctorsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDoctorsApiDoctorsGet>>,
          TError,
          Awaited<ReturnType<typeof listDoctorsApiDoctorsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDoctorsApiDoctorsGet<TData = Awaited<ReturnType<typeof listDoctorsApiDoctorsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoctorsApiDoctorsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Doctors
 */

export function useListDoctorsApiDoctorsGet<TData = Awaited<ReturnType<typeof listDoctorsApiDoctorsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDoctorsApiDoctorsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDoctorsApiDoctorsGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * @summary Create Doctor
 */
export const createDoctorApiDoctorsPost = (
    doctorIn: DoctorIn,
 signal?: AbortSignal
) => {


      return apiClient<DoctorDetailOut>(
      {url: `/api/doctors/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: doctorIn, signal
    },
      );
    }



export const getCreateDoctorApiDoctorsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDoctorApiDoctorsPost>>, TError,{data: DoctorIn}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createDoctorApiDoctorsPost>>, TError,{data: DoctorIn}, TContext> => {

const mutationKey = ['createDoctorApiDoctorsPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDoctorApiDoctorsPost>>, {data: DoctorIn}> = (props) => {
          const {data} = props ?? {};

          return  createDoctorApiDoctorsPost(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDoctorApiDoctorsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createDoctorApiDoctorsPost>>>
    export type CreateDoctorApiDoctorsPostMutationBody = DoctorIn
    export type CreateDoctorApiDoctorsPostMutationError = HTTPValidationError

    /**
 * @summary Create Doctor
 */
export const useCreateDoctorApiDoctorsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDoctorApiDoctorsPost>>, TError,{data: DoctorIn}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createDoctorApiDoctorsPost>>,
        TError,
        {data: DoctorIn},
        TContext
      > => {
      return useMutation(getCreateDoctorApiDoctorsPostMutationOptions(options), queryClient);
    }
    /**
 * @summary Update Doctor
 */
export const updateDoctorApiDoctorsDoctorIdPut = (
    doctorId: number,
    doctorUpdate: DoctorUpdate,
 signal?: AbortSignal
) => {


      return apiClient<DoctorDetailOut>(
      {url: `/api/doctors/${doctorId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: doctorUpdate, signal
    },
      );
    }



export const getUpdateDoctorApiDoctorsDoctorIdPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDoctorApiDoctorsDoctorIdPut>>, TError,{doctorId: number;data: DoctorUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateDoctorApiDoctorsDoctorIdPut>>, TError,{doctorId: number;data: DoctorUpdate}, TContext> => {

const mutationKey = ['updateDoctorApiDoctorsDoctorIdPut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDoctorApiDoctorsDoctorIdPut>>, {doctorId: number;data: DoctorUpdate}> = (props) => {
          const {doctorId,data} = props ?? {};

          return  updateDoctorApiDoctorsDoctorIdPut(doctorId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDoctorApiDoctorsDoctorIdPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateDoctorApiDoctorsDoctorIdPut>>>
    export type UpdateDoctorApiDoctorsDoctorIdPutMutationBody = DoctorUpdate
    export type UpdateDoctorApiDoctorsDoctorIdPutMutationError = HTTPValidationError

    /**
 * @summary Update Doctor
 */
export const useUpdateDoctorApiDoctorsDoctorIdPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDoctorApiDoctorsDoctorIdPut>>, TError,{doctorId: number;data: DoctorUpdate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateDoctorApiDoctorsDoctorIdPut>>,
        TError,
        {doctorId: number;data: DoctorUpdate},
        TContext
      > => {
      return useMutation(getUpdateDoctorApiDoctorsDoctorIdPutMutationOptions(options), queryClient);
    }
    /**
 * Read one doctor, including inactive records, inside the current clinic.
 * @summary Get Doctor
 */
export const getDoctorApiDoctorsDoctorIdGet = (
    doctorId: number,
 signal?: AbortSignal
) => {


      return apiClient<DoctorDetailOut>(
      {url: `/api/doctors/${doctorId}`, method: 'GET', signal
    },
      );
    }




export const getGetDoctorApiDoctorsDoctorIdGetQueryKey = (doctorId: number,) => {
    return [
    `/api/doctors/${doctorId}`
    ] as const;
    }


export const getGetDoctorApiDoctorsDoctorIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getDoctorApiDoctorsDoctorIdGet>>, TError = HTTPValidationError>(doctorId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDoctorApiDoctorsDoctorIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDoctorApiDoctorsDoctorIdGetQueryKey(doctorId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDoctorApiDoctorsDoctorIdGet>>> = ({ signal }) => getDoctorApiDoctorsDoctorIdGet(doctorId, signal);





   return  { queryKey, queryFn, enabled: !!(doctorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDoctorApiDoctorsDoctorIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDoctorApiDoctorsDoctorIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getDoctorApiDoctorsDoctorIdGet>>>
export type GetDoctorApiDoctorsDoctorIdGetQueryError = HTTPValidationError


export function useGetDoctorApiDoctorsDoctorIdGet<TData = Awaited<ReturnType<typeof getDoctorApiDoctorsDoctorIdGet>>, TError = HTTPValidationError>(
 doctorId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDoctorApiDoctorsDoctorIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDoctorApiDoctorsDoctorIdGet>>,
          TError,
          Awaited<ReturnType<typeof getDoctorApiDoctorsDoctorIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDoctorApiDoctorsDoctorIdGet<TData = Awaited<ReturnType<typeof getDoctorApiDoctorsDoctorIdGet>>, TError = HTTPValidationError>(
 doctorId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDoctorApiDoctorsDoctorIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDoctorApiDoctorsDoctorIdGet>>,
          TError,
          Awaited<ReturnType<typeof getDoctorApiDoctorsDoctorIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDoctorApiDoctorsDoctorIdGet<TData = Awaited<ReturnType<typeof getDoctorApiDoctorsDoctorIdGet>>, TError = HTTPValidationError>(
 doctorId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDoctorApiDoctorsDoctorIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Doctor
 */

export function useGetDoctorApiDoctorsDoctorIdGet<TData = Awaited<ReturnType<typeof getDoctorApiDoctorsDoctorIdGet>>, TError = HTTPValidationError>(
 doctorId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDoctorApiDoctorsDoctorIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDoctorApiDoctorsDoctorIdGetQueryOptions(doctorId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * @summary Create Public Repasses Link
 */
export const createPublicRepassesLinkApiDoctorsDoctorIdPublicRepassesLinkPost = (
    doctorId: number,
 signal?: AbortSignal
) => {


      return apiClient<DoctorPublicRepassesLinkOut>(
      {url: `/api/doctors/${doctorId}/public-repasses-link`, method: 'POST', signal
    },
      );
    }



export const getCreatePublicRepassesLinkApiDoctorsDoctorIdPublicRepassesLinkPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPublicRepassesLinkApiDoctorsDoctorIdPublicRepassesLinkPost>>, TError,{doctorId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPublicRepassesLinkApiDoctorsDoctorIdPublicRepassesLinkPost>>, TError,{doctorId: number}, TContext> => {

const mutationKey = ['createPublicRepassesLinkApiDoctorsDoctorIdPublicRepassesLinkPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPublicRepassesLinkApiDoctorsDoctorIdPublicRepassesLinkPost>>, {doctorId: number}> = (props) => {
          const {doctorId} = props ?? {};

          return  createPublicRepassesLinkApiDoctorsDoctorIdPublicRepassesLinkPost(doctorId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePublicRepassesLinkApiDoctorsDoctorIdPublicRepassesLinkPostMutationResult = NonNullable<Awaited<ReturnType<typeof createPublicRepassesLinkApiDoctorsDoctorIdPublicRepassesLinkPost>>>

    export type CreatePublicRepassesLinkApiDoctorsDoctorIdPublicRepassesLinkPostMutationError = HTTPValidationError

    /**
 * @summary Create Public Repasses Link
 */
export const useCreatePublicRepassesLinkApiDoctorsDoctorIdPublicRepassesLinkPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPublicRepassesLinkApiDoctorsDoctorIdPublicRepassesLinkPost>>, TError,{doctorId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPublicRepassesLinkApiDoctorsDoctorIdPublicRepassesLinkPost>>,
        TError,
        {doctorId: number},
        TContext
      > => {
      return useMutation(getCreatePublicRepassesLinkApiDoctorsDoctorIdPublicRepassesLinkPostMutationOptions(options), queryClient);
    }
    /**
 * @summary List Notion Unmatched
 */
export const listNotionUnmatchedApiDoctorsNotionUnmatchedGet = (

 signal?: AbortSignal
) => {


      return apiClient<unknown>(
      {url: `/api/doctors/notion-unmatched`, method: 'GET', signal
    },
      );
    }




export const getListNotionUnmatchedApiDoctorsNotionUnmatchedGetQueryKey = () => {
    return [
    `/api/doctors/notion-unmatched`
    ] as const;
    }


export const getListNotionUnmatchedApiDoctorsNotionUnmatchedGetQueryOptions = <TData = Awaited<ReturnType<typeof listNotionUnmatchedApiDoctorsNotionUnmatchedGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotionUnmatchedApiDoctorsNotionUnmatchedGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNotionUnmatchedApiDoctorsNotionUnmatchedGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotionUnmatchedApiDoctorsNotionUnmatchedGet>>> = ({ signal }) => listNotionUnmatchedApiDoctorsNotionUnmatchedGet(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNotionUnmatchedApiDoctorsNotionUnmatchedGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNotionUnmatchedApiDoctorsNotionUnmatchedGetQueryResult = NonNullable<Awaited<ReturnType<typeof listNotionUnmatchedApiDoctorsNotionUnmatchedGet>>>
export type ListNotionUnmatchedApiDoctorsNotionUnmatchedGetQueryError = unknown


export function useListNotionUnmatchedApiDoctorsNotionUnmatchedGet<TData = Awaited<ReturnType<typeof listNotionUnmatchedApiDoctorsNotionUnmatchedGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotionUnmatchedApiDoctorsNotionUnmatchedGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotionUnmatchedApiDoctorsNotionUnmatchedGet>>,
          TError,
          Awaited<ReturnType<typeof listNotionUnmatchedApiDoctorsNotionUnmatchedGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNotionUnmatchedApiDoctorsNotionUnmatchedGet<TData = Awaited<ReturnType<typeof listNotionUnmatchedApiDoctorsNotionUnmatchedGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotionUnmatchedApiDoctorsNotionUnmatchedGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotionUnmatchedApiDoctorsNotionUnmatchedGet>>,
          TError,
          Awaited<ReturnType<typeof listNotionUnmatchedApiDoctorsNotionUnmatchedGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNotionUnmatchedApiDoctorsNotionUnmatchedGet<TData = Awaited<ReturnType<typeof listNotionUnmatchedApiDoctorsNotionUnmatchedGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotionUnmatchedApiDoctorsNotionUnmatchedGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Notion Unmatched
 */

export function useListNotionUnmatchedApiDoctorsNotionUnmatchedGet<TData = Awaited<ReturnType<typeof listNotionUnmatchedApiDoctorsNotionUnmatchedGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotionUnmatchedApiDoctorsNotionUnmatchedGet>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNotionUnmatchedApiDoctorsNotionUnmatchedGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






